import { Outlet } from "react-router-dom";

const ActivityTemplatesParentPage = () => {
  return <Outlet />;
};

export default ActivityTemplatesParentPage;
